module.exports = __webpack_public_path__ + "img/gas-valve.e5a16d07.png";